import React, { createContext, useContext, useMemo } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

import {
  REACT_APP_GOOGLE_MAPS_KEY,
  REACT_APP_RO_GOOGLE_MAPS_KEY,
} from '../../../constants/envConstants';
import { libraries } from '../../../constants';

const GoogleMapsContext = createContext({ isLoaded: false, loadError: null });

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (!context) {
    throw new Error('useGoogleMaps must be used within GoogleMapsProvider');
  }
  return context;
};

const API_KEY_MAP = {
  'route-optimization': REACT_APP_RO_GOOGLE_MAPS_KEY,
  scheduler: REACT_APP_GOOGLE_MAPS_KEY,
  default: REACT_APP_GOOGLE_MAPS_KEY,
};

export const GoogleMapsProvider = ({ children, apiKeyType = 'default' }) => {
  const selectedApiKey = useMemo(() => {
    return API_KEY_MAP[apiKeyType] || API_KEY_MAP.default;
  }, [apiKeyType]);

  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: selectedApiKey || REACT_APP_GOOGLE_MAPS_KEY,
    libraries,
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};
